import { FeatureFlag } from '@typings';

export const getIsFeatureEnabled = (feature: FeatureFlag) => {
  return window.__SHOWROOM_SETTINGS__[feature] === 'true';
};
